import { render, staticRenderFns } from "./MantenedorGridTodos.vue?vue&type=template&id=30d92a54&"
import script from "./MantenedorGridTodos.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGridTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30d92a54', component.options)
    } else {
      api.reload('30d92a54', component.options)
    }
    module.hot.accept("./MantenedorGridTodos.vue?vue&type=template&id=30d92a54&", function () {
      api.rerender('30d92a54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/MantenedorGridTodos.vue"
export default component.exports